import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './margin.css';
import './padding.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './i18n';
/**
 * 1. http 환경에서 service-worker 사용 가능하게 하는방법 기술되어있는 블로그
 * https://evan-moon.github.io/2019/07/06/pwa-with-notification/
 *
 * 2. 푸시메세지 작업
 * https://blog.hoseung.me/2021-11-28-web-push-notification
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>
);
serviceWorkerRegistration.register();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
